/**
 * Visual Style Editor for Shopify Theme
 * Allows real-time CSS editing and preview
 */

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    storageKey: 'shopify-theme-style-editor',
    showOnLoad: false, // Set to true to auto-show on page load
  };
  
  // Create editor UI
  function createEditor() {
    const editor = document.createElement('div');
    editor.id = 'style-editor';
    editor.innerHTML = `
      <div class="style-editor-panel">
        <div class="style-editor-header">
          <h3>🎨 Style Editor</h3>
          <button id="toggle-editor" class="close-btn">✕</button>
        </div>
        
        <div class="style-editor-tabs">
          <button class="tab active" data-tab="color">Colors</button>
          <button class="tab" data-tab="typography">Typography</button>
          <button class="tab" data-tab="spacing">Spacing</button>
          <button class="tab" data-tab="custom">Custom CSS</button>
        </div>
        
        <div class="style-editor-content">
          <!-- Color Tab -->
          <div class="tab-content active" data-content="color">
            <div class="control-group">
              <label>Primary Color</label>
              <input type="color" id="color-primary" value="#C17767">
              <input type="text" id="color-primary-hex" value="#C17767" readonly>
            </div>
            
            <div class="control-group">
              <label>Secondary Color</label>
              <input type="color" id="color-secondary" value="#8B7355">
              <input type="text" id="color-secondary-hex" value="#8B7355" readonly>
            </div>
            
            <div class="control-group">
              <label>Accent Color</label>
              <input type="color" id="color-accent" value="#D4A574">
              <input type="text" id="color-accent-hex" value="#D4A574" readonly>
            </div>
            
            <div class="control-group">
              <label>Text Color</label>
              <input type="color" id="color-text" value="#1f2937">
              <input type="text" id="color-text-hex" value="#1f2937" readonly>
            </div>
            
            <div class="control-group">
              <label>Background Color</label>
              <input type="color" id="color-background" value="#ffffff">
              <input type="text" id="color-background-hex" value="#ffffff" readonly>
            </div>
          </div>
          
          <!-- Typography Tab -->
          <div class="tab-content" data-content="typography">
            <div class="control-group">
              <label>Heading Font Size</label>
              <input type="range" id="font-heading-size" min="24" max="96" value="56">
              <span class="value-display" id="font-heading-size-value">56px</span>
            </div>
            
            <div class="control-group">
              <label>Body Font Size</label>
              <input type="range" id="font-body-size" min="12" max="24" value="16">
              <span class="value-display" id="font-body-size-value">16px</span>
            </div>
            
            <div class="control-group">
              <label>Font Weight</label>
              <select id="font-weight">
                <option value="400">Regular (400)</option>
                <option value="500">Medium (500)</option>
                <option value="600">Semi-Bold (600)</option>
                <option value="700">Bold (700)</option>
                <option value="800">Extra Bold (800)</option>
                <option value="900">Black (900)</option>
              </select>
            </div>
          </div>
          
          <!-- Spacing Tab -->
          <div class="tab-content" data-content="spacing">
            <div class="control-group">
              <label>Section Padding</label>
              <input type="range" id="spacing-section" min="20" max="120" value="80">
              <span class="value-display" id="spacing-section-value">80px</span>
            </div>
            
            <div class="control-group">
              <label>Element Gap</label>
              <input type="range" id="spacing-gap" min="8" max="64" value="24">
              <span class="value-display" id="spacing-gap-value">24px</span>
            </div>
            
            <div class="control-group">
              <label>Border Radius</label>
              <input type="range" id="border-radius" min="0" max="30" value="8">
              <span class="value-display" id="border-radius-value">8px</span>
            </div>
          </div>
          
          <!-- Custom CSS Tab -->
          <div class="tab-content" data-content="custom">
            <textarea id="custom-css" placeholder="Write your custom CSS here...

Example:
.my-class {
  color: red;
  padding: 20px;
}"></textarea>
            <button class="apply-custom-btn" id="apply-custom">Apply Custom CSS</button>
          </div>
        </div>
        
        <div class="style-editor-footer">
          <button id="reset-styles" class="btn-secondary">Reset</button>
          <button id="copy-css" class="btn-secondary">Copy CSS</button>
          <button id="download-css" class="btn-primary">Download CSS</button>
        </div>
      </div>
      
      <button id="style-editor-toggle" class="style-editor-fab">🎨</button>
    `;
    
    document.body.appendChild(editor);
    initializeEditor();
  }
  
  // Initialize editor functionality
  function initializeEditor() {
    // Tab switching
    document.querySelectorAll('.style-editor-tabs .tab').forEach(tab => {
      tab.addEventListener('click', function() {
        const tabName = this.dataset.tab;
        
        // Update tabs
        document.querySelectorAll('.style-editor-tabs .tab').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        
        // Update content
        document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
        document.querySelector(`.tab-content[data-content="${tabName}"]`).classList.add('active');
      });
    });
    
    // Toggle editor
    document.getElementById('toggle-editor').addEventListener('click', hideEditor);
    document.getElementById('style-editor-toggle').addEventListener('click', showEditor);
    
    // Color controls
    setupColorControls();
    
    // Typography controls
    setupTypographyControls();
    
    // Spacing controls
    setupSpacingControls();
    
    // Custom CSS
    document.getElementById('apply-custom').addEventListener('click', applyCustomCSS);
    
    // Footer buttons
    document.getElementById('reset-styles').addEventListener('click', resetStyles);
    document.getElementById('copy-css').addEventListener('click', copyCSS);
    document.getElementById('download-css').addEventListener('click', downloadCSS);
    
    // Load saved styles
    loadSavedStyles();
  }
  
  function setupColorControls() {
    const colorInputs = ['primary', 'secondary', 'accent', 'text', 'background'];
    
    colorInputs.forEach(color => {
      const colorInput = document.getElementById(`color-${color}`);
      const hexInput = document.getElementById(`color-${color}-hex`);
      
      colorInput.addEventListener('input', function() {
        const value = this.value;
        hexInput.value = value;
        applyColor(color, value);
      });
      
      hexInput.addEventListener('input', function() {
        const value = this.value;
        colorInput.value = value;
        applyColor(color, value);
      });
    });
  }
  
  function setupTypographyControls() {
    const headingSize = document.getElementById('font-heading-size');
    const headingValue = document.getElementById('font-heading-size-value');
    const bodySize = document.getElementById('font-body-size');
    const bodyValue = document.getElementById('font-body-size-value');
    
    headingSize.addEventListener('input', function() {
      const value = this.value;
      headingValue.textContent = value + 'px';
      applyFontSize('heading', value);
    });
    
    bodySize.addEventListener('input', function() {
      const value = this.value;
      bodyValue.textContent = value + 'px';
      applyFontSize('body', value);
    });
    
    document.getElementById('font-weight').addEventListener('change', function() {
      applyFontWeight(this.value);
    });
  }
  
  function setupSpacingControls() {
    const controls = [
      { id: 'spacing-section', value: 'spacing-section-value', prop: '--spacing-sections' },
      { id: 'spacing-gap', value: 'spacing-gap-value', prop: '--spacing-elements' },
      { id: 'border-radius', value: 'border-radius-value', prop: '--border-radius' }
    ];
    
    controls.forEach(({ id, value: valueDisplay, prop }) => {
      const input = document.getElementById(id);
      const display = document.getElementById(valueDisplay);
      
      input.addEventListener('input', function() {
        const val = this.value;
        display.textContent = val + 'px';
        applyCustomProperty(prop, val + 'px');
      });
    });
  }
  
  function applyColor(colorName, value) {
    const cssVar = `--color-${colorName}`;
    applyCustomProperty(cssVar, value);
    saveStyle(cssVar, value);
  }
  
  function applyFontSize(type, size) {
    const elements = type === 'heading' ? 'h1, h2, h3' : 'body';
    const style = document.createElement('style');
    style.id = `dynamic-font-${type}`;
    style.textContent = `${elements} { font-size: ${size}px !important; }`;
    document.head.appendChild(style);
    saveStyle(`font-${type}-size`, size + 'px');
  }
  
  function applyFontWeight(weight) {
    const style = document.createElement('style');
    style.id = 'dynamic-font-weight';
    style.textContent = `body, h1, h2, h3 { font-weight: ${weight} !important; }`;
    document.head.appendChild(style);
    saveStyle('font-weight', weight);
  }
  
  function applyCustomProperty(property, value) {
    if (!document.getElementById('dynamic-styles')) {
      const style = document.createElement('style');
      style.id = 'dynamic-styles';
      document.head.appendChild(style);
    }
    
    const styleSheet = document.getElementById('dynamic-styles').sheet;
    const rule = `:root { ${property}: ${value}; }`;
    
    try {
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    } catch (e) {
      console.error('Error applying style:', e);
    }
  }
  
  function applyCustomCSS() {
    const css = document.getElementById('custom-css').value;
    let style = document.getElementById('dynamic-custom-css');
    
    if (!style) {
      style = document.createElement('style');
      style.id = 'dynamic-custom-css';
      document.head.appendChild(style);
    }
    
    style.textContent = css;
    saveStyle('custom-css', css);
  }
  
  function resetStyles() {
    if (confirm('Reset all styles to default?')) {
      localStorage.removeItem(CONFIG.storageKey);
      location.reload();
    }
  }
  
  function copyCSS() {
    const styles = {
      '--color-primary': document.getElementById('color-primary').value,
      '--color-secondary': document.getElementById('color-secondary').value,
      '--color-accent': document.getElementById('color-accent').value,
      '--color-text': document.getElementById('color-text').value,
      '--color-background': document.getElementById('color-background').value,
    };
    
    let css = ':root {\n';
    Object.entries(styles).forEach(([key, value]) => {
      css += `  ${key}: ${value};\n`;
    });
    css += '}';
    
    navigator.clipboard.writeText(css).then(() => {
      alert('CSS copied to clipboard!');
    });
  }
  
  function downloadCSS() {
    const styles = {
      '--color-primary': document.getElementById('color-primary').value,
      '--color-secondary': document.getElementById('color-secondary').value,
      '--color-accent': document.getElementById('color-accent').value,
      '--color-text': document.getElementById('color-text').value,
      '--color-background': document.getElementById('color-background').value,
    };
    
    let css = ':root {\n';
    Object.entries(styles).forEach(([key, value]) => {
      css += `  ${key}: ${value};\n`;
    });
    css += '}';
    
    const blob = new Blob([css], { type: 'text/css' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'theme-customizations.css';
    a.click();
  }
  
  function saveStyle(key, value) {
    const saved = JSON.parse(localStorage.getItem(CONFIG.storageKey) || '{}');
    saved[key] = value;
    localStorage.setItem(CONFIG.storageKey, JSON.stringify(saved));
  }
  
  function loadSavedStyles() {
    const saved = JSON.parse(localStorage.getItem(CONFIG.storageKey) || '{}');
    
    if (Object.keys(saved).length > 0) {
      Object.entries(saved).forEach(([key, value]) => {
        if (key.startsWith('--')) {
          applyCustomProperty(key, value);
        }
      });
    }
  }
  
  function showEditor() {
    document.getElementById('style-editor').classList.add('visible');
    document.getElementById('style-editor-toggle').style.display = 'none';
  }
  
  function hideEditor() {
    document.getElementById('style-editor').classList.remove('visible');
    document.getElementById('style-editor-toggle').style.display = 'flex';
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createEditor);
  } else {
    createEditor();
  }
  
  // Show on load if configured
  if (CONFIG.showOnLoad) {
    showEditor();
  }
})();

